<template>
  <div class="PlayEndRecommendContainer">
    <div class="text">즐거운 관람되셨나요?</div>
    <div class="desc"><br>이 영상을 본 분들이 즐겨보는<br>다른 영상을 이어서 즐겨보세요!</div>
    <div class="btnArea">
      <ul>
        <li><div class="btnType01 " @click.prevent="showRecomContents">추천영상보기</div></li>
      </ul>
    </div>
    <div class="close" @click.prevent="clsoePopup"></div>
    <div class="dim"></div>
  </div>
</template>

<script>
import { EventBus } from '@/components/eventbus/EventBus'

export default {
  name: 'PlayEndRecommend',
  props: {
    streamingInfo: {
      type: Object
    },
    closePlayEndRecommendPopup: {
      type: Function
    }
  },
  methods: {
    showRecomContents () {
      this.$emit('go-bottom-recommend-tab')
    },
    clsoePopup () {
      this.closePlayEndRecommendPopup()
    }
  },
  computed: {
    content: function () {
      return this.streamingInfo.exitmsg.split('\n').join('<br />')
    }
  }
}
</script>

<style>
  .PlayEndRecommendContainer { position: absolute; top:40px; left:0px;  width: 100%;   height: 225px;   z-index: 1999;  }
  .PlayEndRecommendContainer .text{font-size:20px;position: absolute; top:40px; left:0px; width:100%;text-align:center; color: #ffffff; z-index: 1; }
  .PlayEndRecommendContainer .desc{font-size:12px; position: absolute; top:77px; left:0px; width:100%;text-align:center; color: #ffffff; z-index: 1; }
  .PlayEndRecommendContainer .btnArea{ position: absolute; top:151px; left:0px; width: 100%; z-index: 1;  }
  .PlayEndRecommendContainer .btnArea ul { text-align:center;}
  .PlayEndRecommendContainer .btnArea li { display:inline-block; margin: 0 10px 0 0}
  .PlayEndRecommendContainer .btnArea li:last-child .btnType01{ margin-right: 0}
  .PlayEndRecommendContainer .close { position: absolute; top:10px; left:355px; background: url(../../assets/images/ic-popup-close.png) no-repeat; width: 24px; height: 24px; background-size:100% 100%; z-index: 1}
  .dim {background-color: #000; opacity: 0.7;position: absolute; top:0px; left:0px; width: 100%; height: 305px; }
</style>
